import React from "react";
import { GoogleMap, Marker, InfoWindow, useJsApiLoader,Circle } from "@react-google-maps/api";
import { useMediaQuery } from "@mui/material";
import "./PropertyMaps.css";


const center = {
  lat: 12.9716,
  lng: 77.5946,
};

// DISTANCE CALCULATION FUNCTION
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // KM

  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

const PropertyMaps = ({ properties,center , zoom = 12, }) => {
   // console.log("properties____",properties);
    const isMobile = useMediaQuery("(max-width:768px)");
    const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const [selected, setSelected] = React.useState(null);
  const [isFullscreen, setIsFullscreen] = React.useState(false);

  const containerStyle = {
  width: "100%",
  height: isFullscreen ? "100vh" : isMobile ? "300px" : "200px",
};

// FILTER ONLY 15 KM PROPERTIES
const filteredProperties = properties.filter((property) => {

    const lat = parseFloat(property.ltg_det_latitude);
    const lng = parseFloat(property.ltg_det_longitude);

    // skip invalid lat/lng
    if (isNaN(lat) || isNaN(lng)) return false;

    // calculate distance from center
    const distance = calculateDistance(
      center.lat,
      center.lng,
      lat,
      lng
    );

    // debug
    console.log(
      `${property.ltg_title} => ${distance.toFixed(2)} KM`
    );

    // only show within 15 KM
    return distance <= 15;
  });


//const groupedProperties = properties.reduce((acc, property) => {
 const groupedProperties = filteredProperties.reduce(
    (acc, property) => { 
    const lat = parseFloat(property.ltg_det_latitude);
    const lng = parseFloat(property.ltg_det_longitude);

    if (isNaN(lat) || isNaN(lng)) return acc;

    const key = `${lat},${lng}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(property);

    return acc;
  }, {});
if (!isLoaded) return <p>Loading map...</p>;
return (
  <div className={`map-container ${isFullscreen ? "fullscreen" : ""}`}>
      <button
        className="fullscreen-toggle"
        onClick={() => setIsFullscreen(!isFullscreen)}
      >
        {isFullscreen ? "Exit Fullscreen" : "Full Map View"}
      </button>
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}
    >
       {/* 15 KM CIRCLE */}
        <Circle
          center={center}
          radius={15000}
          options={{
            fillColor: "#1976d2",
            fillOpacity: 0.1,
            strokeColor: "#1976d2",
            strokeOpacity: 0.8,
            strokeWeight: 2,
          }}
        />

        {/* CENTER MARKER */}
        <Marker
          position={center}
          icon={{
            url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
          }}
        />
         {/* PROPERTY MARKERS */}
      {Object.entries(groupedProperties).map(([key, group]) => {
        const [lat, lng] = key.split(',').map(Number);
        const titles = group.map((p) => p.ltg_title).join('\n');

        return (
          <Marker
            key={key}
            position={{ lat, lng }}
            onClick={() => setSelected({ lat, lng, properties: group })}
            title={`${group.length} Properties: ${titles}`} // Tooltip on hover
            
          />
        );
      })}
{/* Default center marker if there's a match at center */}
  {groupedProperties[`${center.lat},${center.lng}`] && (
    <Marker
      position={center}
      icon={{
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
      }}
    />
  )}
  {selected && (
  <InfoWindow
    position={{
      lat: selected.lat,
      lng: selected.lng,
    }}
    onCloseClick={() => setSelected(null)}
  >
    <div>
      <h3 className="font-bold text-lg">Properties at this location:</h3>
      {selected.properties.map((p) => (
        <div key={p.RowID} style={{ marginBottom: '6px' }}>
          <strong>{p.ltg_title}</strong>
          <br />
          <button
            className="text-blue-600 underline"
            onClick={() => {
              console.log("Opening:", `/Property/${p.propertyUrl}`);
              window.open(`/Property/${p.propertyUrl}`, "_blank");
            }}
          >
            View Property
          </button>
        </div>
      ))}
    </div>
  </InfoWindow>
)}


    </GoogleMap>
    </div>
  );
};

export default PropertyMaps;
